/* eslint-disable react/prop-types */
/* eslint-disable max-len */
const React = require('react');
const PropTypes = require('prop-types');
const { Library } = require('dx-devsite-markdown');
const { useI18n } = require('nordic/i18n');

const NewsDetailBody = ({ detail, lang, platform }) => {
  const { i18n } = useI18n();
  const dataToEdit = detail;
  const wordSearch = '<dev>';
  const wordReplace = '&lt;dev&gt;';

  const regularExp = new RegExp(wordSearch, 'g');
  const newDetail = dataToEdit.replace(regularExp, wordReplace);
  return (
    <Library
      i18n={i18n}
      key="unique-key"
      input={newDetail}
      siteId={platform.siteId}
      lang={lang}
    />
  );
};

NewsDetailBody.propTypes = {
  i18n: PropTypes.shape({
    gettext: PropTypes.func.isRequired,
  }),
};

module.exports = NewsDetailBody;
